import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LabelComponent } from '../label/label.component';
import { PhotoComponent } from '../photo/photo.component';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { ButtonComponent } from '../button/button.component';
import { EComponentSize, EIcon, ELabelType, IComponentSection } from '../../types';
import { DTO, Types } from 'shared-lib';
import { ToastService } from '../toast/toast.service';
import { AuthService } from '../auth/auth.service';
import { LoadingService } from '../loading/loading.service';
import { FileService } from '../../service/files.service';
import { CircularProgressComponent } from '../circular-progress/circular-progress.component';
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';
import { helper, RelativeDatePipe } from '../../../public-api';
import { ChatService, ProfileService } from '../../service';
import { IconComponent } from "../icon/icon.component";

@Component({
    selector: 'ui-other-user',
    standalone: true,
    imports: [CommonModule, LabelComponent, PhotoComponent, DynamicFormComponent, ButtonComponent, CircularProgressComponent, ImageViewerComponent, RelativeDatePipe, IconComponent],
    templateUrl: './other-user.component.html',
    styleUrl: './other-user.component.scss',
})
export class OtherUserComponent implements OnInit {
    loading = signal(true);
    userId: number | undefined = undefined;
    user: DTO.UserDTO | undefined;
    currentUser: DTO.JwtDTO | undefined;
    avatar: any = null;
    sameUser: boolean = false;

    imagePreview = false;
    imageUrlViewer = '';

    files: any[] = [];
    currentTab: 'info' | 'photos' = 'info';

    EComponentSize = EComponentSize;
    ELabelTypes = ELabelType;
    EAlert = Types.EAlert;
    EIcon = EIcon;
    currentFields: IComponentSection[] = [];

    profileComplete: number | undefined = undefined;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private toastService: ToastService,
        private chatService: ChatService,
        private authService: AuthService,
        private loadingService: LoadingService,
        private profileService: ProfileService,
        private fileService: FileService,
    ) { }

    async ngOnInit() {
        this.route.paramMap.subscribe(async (params) => {
            this.userId = params.get('id') ? Number(params.get('id')) : undefined;
            await this.fetchUserData();
            this.fetchMyData();
            await this.fetchUserPhotos();

            this.sameUser = this.user?.id == this.currentUser?.sub;
        });
    }

    async fetchUserData() {
        this.loadingService.start();
        let userResponse = await this.authService.getUserInfo(this.userId);

        if (userResponse) {
            this.user = userResponse;
            this.fillFields();
            this.getProfileComplete()
        } else {
            this.toastService.add(
                `Erro ao receber usuário.`,
                30000,
                'warning'
            );
        }
        this.loadingService.stop();
        this.loading.set(false);
    }

    async getProfileComplete(){
        this.profileComplete = await this.profileService.getProfileComplete(this.user?.id ?? '') ?? 0;
    }

    fetchMyData(){
        this.currentUser = this.authService.getUser();
    }

    fillFields() {
        this.currentFields = [];

        let personalInfo = {
            name: 'Informações pessoais',
            selector: 'personal',
            content: [
                {
                    component: 'TextComponent',
                    selector: 'name',
                    inputs: {
                        editable: false,
                        placeHolder: 'Nome',
                        default: '',
                        value: this.user?.name,
                        type: Types.EInput.TEXT,
                        required: true,
                    },
                },
                {
                    component: 'TextComponent',
                    selector: 'lastName',
                    inputs: {
                        editable: false,
                        placeHolder: 'Sobrenome',
                        default: '',
                        value: this.user?.lastName,
                        type: Types.EInput.TEXT,
                        required: true,
                    },
                },
                {
                    component: 'TextComponent',
                    selector: 'phone',
                    inputs: {
                        editable: false,
                        placeHolder: 'Celular',
                        default: '',
                        value: this.user?.phone,
                        type: Types.EInput.PHONE,
                        required: true,
                    },
                },
                {
                    component: 'TextComponent',
                    selector: 'birthDate',
                    inputs: {
                        editable: false,
                        placeHolder: 'Data de Nascimento',
                        default: '',
                        value: String(this.user?.birthDate),
                        type: Types.EInput.DATE,
                        required: true,
                    },
                },
            ],
        };
        this.currentFields.unshift(personalInfo);
    }

    async fetchUserPhotos() {
        this.loadingService.start();
        this.files = [];
    
        let filesUser = await this.fileService.getMultiplesFiles(this.userId);
        if (filesUser && filesUser.length > 0) {
          filesUser.forEach(async (file) => {
            let fileDTO = new DTO.UploadDTO();
            fileDTO.id = file.id;
            const fileContent = await this.fileService.loadFile(file.id);
            if (this.user?.avatar?.id === file.id) {
                this.avatar = {
                    id: file.id,
                    path: fileContent
                  }
              return;
            }
            fileDTO.path = fileContent ?? '';
            fileDTO.mimetype = file.mimetype;
            fileDTO.name = file.name;
            fileDTO.originalname = file.originalname;
            fileDTO.size = file.size;
            this.files.push(fileDTO);
          });
        }
        this.loadingService.stop();
        this.loading.set(false);
    }

    changeTab(tab: 'info' | 'photos') {
        this.currentTab = tab;
    }

    editProfile(){
        this.router.navigate(['/profile']);
    }

    openImage(imageUrl: string){
        this.imageUrlViewer = imageUrl;
        this.imagePreview = true;
    }

    async addContact(){
        this.router.navigate(['/chat', this.userId]);
    }
}
